module.exports = __webpack_public_path__ + "img/SAVE.d1303609.svg";